import { type AuthOptions, createAuthClient } from '@storebrand-digital/auth';

const options: AuthOptions = {
  config: {
    realm: window.env.KEYCLOAK_REALM,
    clientId: window.env.KEYCLOAK_CLIENT,
    url: window.env.KEYCLOAK_URL,
  },
  init: {
    scope: window.env.KEYCLOAK_SCOPES,
  },
  login: {
    scope: window.env.KEYCLOAK_SCOPES,
    allowedACR: [
      'https://id.storebrand.no/authn/al3',
      'https://id.storebrand.no/authn/al4',
    ],
    allowedAMR: ['pwd:mfa'],
  },
};

const auth = createAuthClient(options);

export default auth;
